import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./EnergyServicesHomeStyles";
import Header from "../components/Header";
import EnergyServicesNavigation from "../components/EnergyServicesNavigation";
import { energyActions, activityActions } from "../_actions";
import { connect } from "react-redux";
import Loading from "../components/Loading";
import PageTitle from "../components/PageTitle";
//import RankingBanner from '../components/RankingBanner';
import FrequencySelector from "../components/FrequencySelector";
import SelectMenu from "../components/SelectMenu";
import DailyBreakdown from "../components/DailyBreakdown";
import BreakdownChart from "../components/BreakdownChart";
import AppliancesTitle from "../components/AppliancesTitle";
import AppliancesUsedToday from "../components/AppliancesUsedToday";
import AppliancesMostUsed from "../components/AppliancesMostUsed";
import AppliancesMostCostly from "../components/AppliancesMostCostly";
import PopupWrapper from "../components/PopupWrapper";
import EnergyTimeline from "../components/EnergyTimeline";

class EnergyServicesUsage extends Component {
  constructor(props) {
    super(props);
    let user = JSON.parse(localStorage.getItem("user"));
    const unix = Math.round(+new Date() / 1000);
    // props.dispatch(
    //   energyActions.getDetail(user, props.energy.usageFrequency, unix)
    // );

    props.dispatch(
      energyActions.getTimeline(
        this.props.authentication.user.user_id,
        Math.round(new Date() / 1000)
      )
    );
  }

  componentDidUpdate(prevProps) {
    let user = JSON.parse(localStorage.getItem("user"));
    if (this.props.energy.usageFrequency !== prevProps.energy.usageFrequency) {
      if (this.props.energy.usageFrequency === "timeline") {
        this.props.dispatch(
          energyActions.getTimeline(
            this.props.authentication.user.user_id,
            Math.round(new Date() / 1000)
          )
        );
      } else {
        const unix = Math.round(+new Date() / 1000);
        this.props.dispatch(
          energyActions.getDetail(user, this.props.energy.usageFrequency, unix)
        );
      }
    } else if (
      this.props.energy.detailItem !== prevProps.energy.detailItem &&
      this.props.energy.usageFrequency !== "timeline"
    ) {
      this.props.dispatch(
        energyActions.getDetail(
          user,
          this.props.energy.usageFrequency,
          this.props.energy.detailItem
        )
      );
    }
  }

  render() {
    const { fetchingDetail, detail, usageFrequency } = this.props.energy;

    return (
      <div>
        <Header
          title={"My Home"}
          backTitle={"Dashboard"}
          backHref={"/"}
          isHomeView={true}
        />
        <PageTitle
          title={"Usage"}
          subTitle={"See a detailed breakdown of your energy usage."}
        />
        <EnergyServicesNavigation {...this.props.location} />
        <div className={css(styles.container)}>
          <PopupWrapper />
          <FrequencySelector {...this.props} />

          {fetchingDetail && <Loading />}
          {usageFrequency === "timeline" && (
            <div>
              <EnergyTimeline {...detail} />
            </div>
          )}
          {usageFrequency !== "timeline" &&
            this.props.energy.detail &&
            this.props.energy.detail.details && (
              <div>
                {detail.available && <SelectMenu {...this.props} />}

                {!fetchingDetail && detail.period && (
                  <div>
                    <DailyBreakdown {...detail} filterable showPraise />
                    <BreakdownChart {...this.props} />
                    <div className={css(styles.innerNarrow)}>
                      <AppliancesTitle {...detail.period} />
                      <AppliancesUsedToday {...detail} />
                      <AppliancesMostUsed {...detail} />
                      <AppliancesMostCostly {...detail} />
                    </div>
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { fetchingDetail } = state.energy;
  const { alert } = state;
  const energy = state.energy;
  const authentication = state.authentication;
  const activity = state.activity;
  return {
    fetchingDetail,
    alert,
    energy,
    authentication,
    activity
  };
}

export default connect(mapStateToProps)(EnergyServicesUsage);
